module.exports = __webpack_public_path__ + "img/grupo-planeta.a8e9b558.png";